import axios, { Method } from '@/apps/open/utils/axios'

const serverPath = '/writing_helper'

/**
 * 获取AI智能写作的应用列表
 */
export const getAIApps = (params: object) => axios({ url: `${serverPath}/helper/oauth/get_developer_apis`, method: Method.Post, params, data: params })

/**
 * 申请AI应用
 */
export const applyAiApp = (params: object) => axios({ url: `${serverPath}/helper/oauth/open_create_api`, method: Method.Post, data: params })

/**
 * 更新AI应用
 */
export const updateAiApp = (params: object) => axios({ url: `${serverPath}/helper/oauth/open_set_api_info`, method: Method.Post, data: params })

/**
 * 根据应用id获取应用信息
 */
export const getAiAppDetail = (params: object) => axios({ url: `${serverPath}/helper/oauth/get_api_info`, method: Method.Post, data: params })
